import { z } from 'zod'
import { fuelEnum } from './fuels'

// These are defined here to enable us to use them in the generated schema.ts in the postgres package
// Look at .kysely-codegenrc.ts in the postgres package to see how it's being used for the generated schema

export const AirTravelSchema = z.object({
	distance: z.enum(['short_haul', 'medium_haul', 'long_haul']),
})

export const FuelUseOrPurchaseSchema = z.object({
	fuel_type: fuelEnum,
})

export const RoadTravelSchema = z.object({
	vehicle_type: z.string().optional(),
	electric_vehicle: z.boolean().optional(),
})

export const SeaTravelSchema = z.object({
	includes_vehicle: z.boolean().optional(),
})

export const ActivitiesAdditionalDataSchema = z.union([
	AirTravelSchema,
	FuelUseOrPurchaseSchema,
	RoadTravelSchema,
	SeaTravelSchema,
])

export type ActivitiesAdditionalData = z.infer<
	typeof ActivitiesAdditionalDataSchema
>
